import React from 'react'
import { Pane , Switch, Strong } from 'evergreen-ui'

const week = [
  "Domingo",
  "Segunda-feira",
  "Terça-feira",
  "Quarta-feira",
  "Quinta-feira",
  "Sexta-feira",
  "Sábado"
]

const ToggleWeek = ({
  days, handleDayChange
  }) => {
  
  return (
    <Pane display="flex" paddingBottom={15} paddingTop={5} background="#fff" borderRadius={0}>
       <Pane flex={1} alignItems="center" display="flex">
        {
          week.map((day,index) => (
            <Pane key={day} width={120}>
              <Strong>{day}</Strong>
              <Switch
              name={day}
              height={24}
              checked={ days.includes(index + 1)}
              onChange={() => {
                handleDayChange(index + 1, !days.includes(index + 1));
              }}
            />
            </Pane>
          ))
        }
        </Pane>
    </Pane>
  )
}

export default ToggleWeek
